// extracted by mini-css-extract-plugin
export default {"ExtraPerformanceAdviceSection":"style_ExtraPerformanceAdviceSection__IqwnH","GlobalText2":"style_GlobalText2__Uot2H"};